/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import {
  fetchTickets,
  fetchFilterTickets,
  updateTicketStatus,
  updateCriticalStatus,
  fetchDataBasedOnTktId,
  submitTicketStatus,
  getLocation,
  deleteAttachment,
  fetchCompanies,
  fetchCategoriesAndSubCategories,
  searchTickets,
  submitComment,
  submitReassign,
  getTicketCounts,
  fetchDepartment,
  fetchTicketStatus,
  fetchTicketType,
  quickFilter,
  fetchDepartmentForReassign,
  fetchMyTickets,
  fetchDataBasedOnTktIdTwo,
  getMyTicketKpiCount,
  searchMyTickets,
  getAssigneeBaseInfo,
  searchMyTickets2,
  submitIrrelevant,
} from "../../utils/API/TicketAPI";
import { useToken } from "../../utils/TokenContext";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Ticket from "./Ticket";
import TicketDetails from "./TicketDetails";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import Filter from "./Filter";
import "./Tickets.css";
import MarkCriticalModal from "./Modals/MarkCriticalModal";
import ChangeStatusModal from "./Modals/ChangeStatusModal";
import NoDataBg from "../../assests/img/No-data-bg.svg";
import "react-toastify/dist/ReactToastify.css";
import { handleLogOut } from "../../utils/ClearCache";
import debounce from "lodash.debounce";
import { useLocation } from "react-router-dom";
import starIcon from "../../assests/img/Ratings/star-icon.svg";
import { Button, Modal } from "react-bootstrap";
import axiosInstance from "../../utils/axiosInstance";

const TicketLists = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const globalTicket = queryParams.get("ticketNumber");

  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [modalTicketId, setModalTicketId] = useState("");
  const [modalButtonValue, setModalButtonValue] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [loading, setLoading] = useState(false);
  // const { token } = useToken();
  const token = localStorage.getItem("token");
  const [allData, setAllData] = useState([]);
  const [escData, setEscData] = useState([]);
  const [allTicketData, setAllTicketData] = useState([]);
  const [time, setTime] = useState("00:00");
  const [activeTabDet, setactiveTabDet] = useState("overview");
  const [locationData, setLocationData] = useState([]);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [hasMoreTickets, setHasMoreTickets] = useState(true);
  // const [isValidToken, setIsValidToken] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // State to store search query
  const [isSearching, setIsSearching] = useState(false); // State to handle search state
  const [commentbox, setCommentBox] = useState("");
  const [uploadedFilesComment, setUploadedFilesComment] = useState([]);
  const [commentType, setCommentType] = useState(false);
  const [reassignbox, setReassignBox] = useState("");
  const [uploadedFilesReassign, setUploadedFilesReassign] = useState([]);
  const [irrelevantBox, setIrrelevantBox] = useState("");
  const [uploadedFilesIrrelevant, setUploadedFilesIrrelevant] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [ticketCount, setTicketCount] = useState({});
  const [selectedTicketStatus, setSelectedTicketStatus] = useState([]);
  const [selectedRatings, setSelectedRatings] = useState([]);

  const [filterTab, setFilterTab] = useState("open");

  const [showLoader, setShowLoader] = useState(false);
  const [redirectStatus, setRedirectStatus] = useState(
    localStorage.getItem("tktStatus")
  );

  const [applyFilterValue, setApplyFilterValue] = useState(null);

  const [supportTicketChecked, setSupportTicketChecked] = useState(false);

  const [quick, setQuick] = useState([]);

  const [quickClearFilterDisable, setQuickClearFilterDisable] = useState(null);

  const [checkedStates, setCheckedStates] = useState(
    quick.reduce((acc, item) => {
      acc[item.label] = false; // Initialize all as unchecked
      return acc;
    }, {})
  );

  const [show, setShow] = useState(false);
  const [dynamicData, setDynamicData] = useState([]);
  const [raiseticketStatud, setRaiseticketStatud] = useState(false);
  const [dataRaiseTT, setDataRaiseTT] = useState([]);
  const [myTicketKpiCount, setMyTicketKpiCount] = useState({});

  const [myTicketsTab, setMyTicketsTab] = useState("");

  const [userRoles, setUserRoles] = useState([]);
  const [isTicketManager, setIsTicketManager] = useState(false);
  const [isTicketUser, setIsTicketUser] = useState(false);

  const [userDetails, setUserDetails] = useState('');
  const [groupTypeOpExistAm, setGroupTypeOpExistAm] = useState(false);
  const [groupTypeForExComment,setGroupTypeForExComment] = useState(false);
  const [groupTypeOpsExist,setGroupTypeOpsExist]= useState(false);

  const fullName = `${userDetails?.fname || ""} ${userDetails?.lname || ""}`.trim();
  localStorage.setItem("name", fullName);
  localStorage.setItem("email", userDetails?.email);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const observer = useRef();

  // if(globalTicket){
  //   setSearchQuery(globalTicket)
  // }
  // Filter the assignee array
  // const filteredAssignees = ["tc", "it", "op"].filter(
  //   (i) => i !== ticketDetails?.assignee[0].groupType
  // );



  const handleChangeAssignee = (event) => {
    setSelectedAssignee(event.target.value);
  };

  // useEffect(() => {
  //   if (!isValidToken) {
  //     handleLogOut();
  //     // window.location.href = "/";
  //   }
  // }, [isValidToken]);

  // useEffect(() => {
  //   if(globalTicket){
  //     const localActiveTab = localStorage.getItem("activeTab");
  //   if (localActiveTab) {
  //     setFilterTab(localActiveTab);
  //     if(localActiveTab === "all" || localActiveTab === "pastdue" ) {
  //       setFilterTab("open");
  //     }

  //     localStorage.removeItem("activeTab");
  //   } else {
  //     setFilterTab("open");
  //   }
  //   } else {
  //     setActiveTab('open')
  //   }

  // }, []);

  useEffect(() => {
    if (globalTicket) {
      if (redirectStatus && redirectStatus == "Done") {
        setFilterTab("closed");
        setRedirectStatus(null);
      } else setFilterTab("open");
    } else {
      setActiveTab("open");
    }
  }, []);

  useEffect(() => {
    if (locationData.length > 0) {
      const allOptions = locationData.map((location) => ({
        value: location._id,
        label: location.locationName,
      }));
      setSelectedLocation(allOptions);
    }
  }, [locationData]); // empty dependency array

  useEffect(() => {
    setCurrentPage(1);
    if (globalTicket) {
      getTicketCountData();
      fetchMyTicketKpiCount();
    }
  }, [selectedLocation]);

 const handleTabClick = (tab) => {
    if (tab === "opened" || tab === "close") {
      setMyTicketsTab(tab);
      setActiveTab(tab);
      setFilterTab(tab);
      setSearchQuery("");
      setTickets([]);
      setCurrentPage(1);
      setHasMoreTickets(true);
      setTicketDetails(null);
      return;
    }
    if (activeTab === "Filter" || activeTab === "Search") {
      setFilterTab(tab);
    } else {
      setFilterTab(tab);
      setActiveTab(tab);
      setSearchQuery("");
    }
    setTicketDetails(null);
    setTickets([]);
    setCurrentPage(1);
    setHasMoreTickets(true);
  };

  const fetchData = async (page, view, location) => {
    try {
      setLoading(true);

      setShowLoader(true); // Show loader when starting to fetch

      let response;

      if (activeTab === "opened" || activeTab === "close") {

        response = await fetchMyTickets(page, view, location);

      } else {

        response = await fetchTickets(page, view, location);

      }
      if (response?.data?.statusValue === 200) {
        const newTickets = response.data.data;

        if (newTickets.length === 0) {
          setHasMoreTickets(false);
        } else if (selectedLocation.length === 0) {
          setTickets([]);
        } else {
          setHasMoreTickets(true);
          setTickets((prevTickets) => {
            const combinedTickets = [...prevTickets, ...newTickets];
            const uniqueTickets = removeDuplicates(combinedTickets);
            return uniqueTickets;
          });
        
          if (tickets.length === 0 && newTickets.length > 0) {
            setTicketDetails(newTickets[0]);
          }
        }
      } else {
        setTickets([]);
        toast.error(response?.data?.data?.message);
      }
    } catch (error) {
      showToast(
        `Error fetching ticket : ${error?.response?.data?.error?.message}`
      );
    } finally {
      setTimeout(() => {
        setLoading(false);
        setShowLoader(false);
      }, 700);
    }
  };
  // Popup Modal - Mark Critical
  const [MarkCriticalModalShow, setMarkCriticalModalShow] = useState(false);

  useEffect(() => {
    //  if (selectedLocation.length > 0 ) {
    //   getTicketCountData();
    //  }

    if (
      selectedLocation.length > 0 &&
      activeTab !== "Filter" &&
      activeTab !== "Search"
    ) {
      fetchData(
        currentPage,
        activeTab?.toLowerCase(),
        selectedLocation.map((location) => location.value).join(",")
      );
      //getTicketCountData()
    } else if (
      activeTab === "Filter" ||
      (activeTab === "Filter" && activeTab === "Location")
    ) {
      fetchFilterData(
        currentPage,
        selectedFilters,
        selectedCompanies,
        selectedDepartments,
        selectedCategories,
        selectedSubCategories,
        selectedTicketTypes,
        selectedStatus,
        fromDate,
        toDate,
        selectedLocation.map((location) => location.value).join(",")
      );
    } else if (activeTab === "Search") {
      fetchSearchResults(
        searchQuery,
        currentPage,
        selectedLocation.map((location) => location.value),
        globalTicket ? 1 : ""
      );
      if (globalTicket) {
        getTicketCountData(
          searchQuery,
          selectedLocation.map((location) => location.value)
        );
      }
    } else {
      setTickets([]);
      setTicketDetails(null);
    }
    if(raiseticketStatud){
      getTicketCountDataRefresh();
      setRaiseticketStatud(false);
    }
  }, [currentPage, activeTab, selectedLocation, filterTab, raiseticketStatud]);

  useEffect(()=>{
    console.log(tickets,"step1")
  },[tickets])

  useEffect(()=> {
    const fetchData = async () => {
      try {
        setLoading(true);
        setShowLoader(true);

        let response;
        if (isTicketUser && !isTicketManager) {
          // For Ticket Users, fetch My Tickets based on activeTab
          response = await fetchMyTickets(1, activeTab?.toLowerCase() || "opened", "");
          
          if (response?.data?.statusValue === 200) {
            const newTickets = response.data.data;
            console.log(newTickets,"newTickets")
            
            if (newTickets.length === 0) {
              setHasMoreTickets(false);
              setTickets([]);
            } else {
              setHasMoreTickets(true);
              setTickets(newTickets);
              console.log(tickets,"asjdgjahsdgjhasgdhjasdg")

              if (newTickets.length > 0) {
                setTicketDetails(newTickets[0]);
                setSelectedTicketId(newTickets[0]._id);
              }
            }
          } else {
            setTickets([]);
            toast.error(response?.data?.data?.message);
          }
        }

      } catch (error) {
        showToast(
          `Error fetching tickets: ${error?.response?.data?.error?.message}`
        );
      } finally {
        setTimeout(() => {
          setLoading(false);
          setShowLoader(false);
        }, 700);
      }
    };

    if (isTicketUser && !isTicketManager) {
      fetchData();
      fetchMyTicketKpiCount();
    }
  }, [isTicketUser, activeTab]);

  // Add this useEffect to handle initial load for Ticket Users
  useEffect(() => {
    if (isTicketUser && !isTicketManager) {
      setActiveTab("opened");
      setFilterTab("opened");
      setMyTicketsTab("opened");
    }
  }, [isTicketUser]);

  useEffect(() => {
    if (ticketDetails) {
      fetchAllData(ticketDetails?._id);
      setSelectedTicketId(ticketDetails?._id);
    }
  }, [ticketDetails]);

  // Set the first ticket as selected by default when component mounts
  useEffect(() => {
    if (tickets.length > 0 && selectedTicketId === null || (isTicketUser && !isTicketManager)) {
      setSelectedTicketId(tickets[0]?._id);
    }
  }, [tickets]);

  const handleSelectButtonClick = async (ticketId) => {
    let ticketData = {};
    tickets.forEach((e) => {
      if (e._id === ticketId) ticketData = e;
    });
    setTicketDetails(ticketData);
    setSelectedTicketId(ticketId);
    setactiveTabDet("overview");
  };
  
  const fetchAllData = async (id) => {
    console.log(filterTab,"ashdfasjfdhags")
    try {
      let response;
      if (activeTab === "opened" || activeTab === "close" || filterTab === "opened" || filterTab === "close" || (isTicketUser && !isTicketManager) ) {
        response = await fetchDataBasedOnTktIdTwo(id);
      } else {
        response = await fetchDataBasedOnTktId(id);
      }
      if (response.statusValue === 200) {
        setAllData(response.data.actionTimeline);
        setEscData(response.data.escalationTimeline);
        setAllTicketData(response.data);
        setTime(response?.data?.internalSla?.consumedSla);

        return response.data;
      } else {
        setAllData([]);
        return {};
      }
    } catch (error) {
      console.error("Error fetching ticket data:", error);
      return {};
    }
  };

  const removeDuplicates = (tickets) => {
    const seen = new Set();
    const uniqueTickets = tickets.filter((ticket) => {
      if (seen.has(ticket._id)) {
        return false;
      } else {
        seen.add(ticket._id);
        return true;
      }
    });
    return uniqueTickets.sort(
      (a, b) => new Date(b.sortByDate) - new Date(a.sortByDate)
    );
    // return uniqueTickets;
  };

  const uniqueLists = async (ticketId = "") => {
    const resTicketData = await fetchAllData(
      ticketId ? ticketId : modalTicketId
    );
    setTicketDetails(resTicketData);
    setTickets((prevTickets) => {
      const uniqueTickets = removeDuplicates(prevTickets);

      return uniqueTickets.map((ticket) =>
        ticket._id === (ticketId ? ticketId : modalTicketId)
          ? resTicketData
          : ticket
      );
    });
  };

  const showToast = (message) => {
    toast.error(message);
  };

  const showToastSuccess = (message) => {
    toast.success(message);
  };

  const handleButtonClick = async (ticketId, buttonValue) => {
    console.log("abcd");
    try {
      // Skip API calls if buttonValue is Comments, Reassign, or Irrelevant
      let response = null;
      let completeFormResponse = null;
  
      if (
        buttonValue !== "Comments" &&
        buttonValue !== "Reassign" &&
        buttonValue !== "Irrelevant"
      ) {
        // Check via API if status access returns dynamic fields
        response = await axiosInstance.get(`ticket/change_status_access`, {
          params: {
            status: buttonValue,
            ticketId: ticketId,
          },
        });
  
        // Fetch completeform data
        completeFormResponse = await axiosInstance.get(
          `workflow/completeform/${ticketId}?status=${buttonValue}`
        );
  
        if (response?.data?.statusValue === 200) {
          setDynamicData(response.data.data);
        }
  
        if (response.data.data && Object.keys(response.data.data).length > 0) {
          handleShow();
          return; // Stop further execution if dynamic form exists
        }
      }
  
      // Check local statusOption fields
      const statusObj = ticketDetails?.statusOption?.find(
        (e) => e.status === buttonValue
      );
      const hasFields = statusObj?.fields && statusObj.fields.length > 0;
  
      // Set modal data
      setModalTicketId(ticketId);
      setModalButtonValue(buttonValue);
  
      if (
        hasFields ||
        buttonValue === "Comments" ||
        buttonValue === "Reassign" ||
        buttonValue === "Irrelevant"
      ) {
        // Show modal if local config fields exist
        setShowChangeStatusModal(true);
      } else {
        // No fields — proceed with direct status update
        const resData = await updateTicketStatus(ticketId, buttonValue);
        if (resData?.statusText === "Failed") {
          showToast(`${resData?.message}`);
        } else if (resData?.statusValue === 400) {
          showToast(resData?.message);
        } else {
          // Refresh ticket data after status update
          await uniqueLists(ticketId);
          showToastSuccess("Status updated successfully");
          // Fetch updated completeform data
          if (
            completeFormResponse &&
            completeFormResponse?.data?.statusValue === 200
          ) {
            setAllTicketData((prev) => ({
              ...prev,
              formConfig: completeFormResponse.data.data,
            }));
          }
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };
  
  
  const handleCriticalButtonClick = async (ticketId) => {

    setMarkCriticalModalShow(true);
  };

  const confirmCriticalAction = async () => {
    try {
      await updateCriticalStatus(ticketDetails?._id, true);
      setMarkCriticalModalShow(false);
      uniqueLists(ticketDetails?._id);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleUpdateStatus = async (status, values, prevAttachment = []) => {
    console.log(prevAttachment, "valuesvaluesvalues");
    try {
      const response = await submitTicketStatus(
        modalTicketId,
        status,
        values,
        prevAttachment
      );
  
      if (response.statusValue === 200) {
        setShowChangeStatusModal(false);
        showToastSuccess("Status updated successfully");
        // Refresh ticket data
        await uniqueLists();
        // Fetch updated completeform data
        const completeFormResponse = await axiosInstance.get(
          `workflow/completeform/${modalTicketId}?status=${status}`
        );
        if (completeFormResponse?.data?.statusValue === 200) {
          setAllTicketData((prev) => ({
            ...prev,
            formConfig: completeFormResponse.data.data, // Update form config
          }));
        }
      } else if (response.statusValue === 400) {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast(
        `Error fetching update status : ${error?.response?.data?.error?.message}`
      );
    }
  };
  

  const handleAddComment = async (message, commentFile, commentType, clientResponseRequired) => {
    try {
      const response = commentType
      ? await submitComment(modalTicketId, message, commentFile, commentType, clientResponseRequired)
      : await submitComment(modalTicketId, message, commentFile, commentType);
      if (response.statusValue === 200) {
        setShowChangeStatusModal(false);
        uniqueLists();
      } else if (response.statusValue === 400) {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast(
        `Error fetching comment  : ${error?.response?.data?.error?.message}`
      );
    }
  };

  const handleReassign = async (message, reassignFile, to) => {
    try {
      const response = await submitReassign(
        modalTicketId,
        message,
        reassignFile,
        to
      );
      if (response.statusValue === 200) {
        setShowChangeStatusModal(false);
        uniqueLists();
      } else if (response.statusValue === 400) {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast(
        `Error fetching reassign  : ${error?.response?.data?.error?.message}`
      );
    }
  };




  const handleIrrelevant = async (message, irrelevantFile, to) => {
    try {
      const response = await submitIrrelevant(
        modalTicketId,
        message,
        irrelevantFile,
        to
      );

      if (response.message === "Ticket marked as relevant successfully." || response.message === "Ticket marked as irrelevant successfully.") {
        setShowChangeStatusModal(false);
        uniqueLists();
      } else {
        showToast(response.message);
      }
    } catch (error) {
      console.log(error, "error");
      showToast(
        `Error fetching irrelevant  : ${error?.response?.data?.error?.message}`
      );
    }
  };

  const fetchAllLocation = async (page) => {
    try {
      const response = await getLocation(page);
      if (response.statusValue === 200) {
        setLocationData(response.data);
      } else {
        setLocationData([]);
      }
    } catch (error) {
       setSelectedLocation([1])  
    }
  };

  useEffect(() => {
    fetchAllLocation(currentPage);
  }, []);

  // Intersection Observer
  const lastTicketElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreTickets) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMoreTickets]
  );

  // Filter Code
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [allSubCategoryOptions, setAllSubCategoryOptions] = useState([]);
  const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState(
    []
  );
  const [isApplyFilterDisabled, setIsApplyFilterDisabled] = useState(true);
  const [filterCount, setFilterCount] = useState(0);
  const [showClearAll, setShowClearAll] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [ticketStatusOptions, setTicketStatusOptions] = useState([]);
  const [ticketTypeOptions , setTicketTypeOptions] = useState([]);
  const [departmentOptionForReassign, setDepartmentOptionForReassign] = useState([]);

  // const departmentOptions = [
  //   { label: "Operations", value: "op" },
  //   { label: "IT", value: "it" },
  //   { label: "Tech", value: "tc" },
  //   { label: "Account Management", value: "am" },
  //   { label: "MSD", value: "md" },
  //   { label: "InfoSec", value: "is" },
  // ];

  // const ticketTypeOptions = [
  //   { label: "Internal", value: "internal" },
  //   { label: "Support", value: "support" },
  //   { label: "Service", value: "service" },
  //   { label: "SPOC", value: "spoc" },
  //   { label: "MSD", value: "msd" },
  // ];

  // const ticketStatusOptions = [
  //   { label: "To Do", value: "To Do" },
  //   { label: "In Progress", value: "In Progress" },
  //   { label: "Under Review", value: "Under Review" },
  //   { label: "Reopened", value: "Reopen" },
  //   { label: "Done", value: "Done" },
  // ];

  const fetchDepartmentOptions = async () => {
    try {
      const response = await fetchDepartment();
      if (response.data.statusValue === 200) {
        const departments = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((dept) => ({
            label: dept.label,
            value: dept.value,
          }));

        setDepartmentOptions(departments);
      } else {
        setDepartmentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching department names", error);
    }
  };

  const fetchTicketStatusOptions = async () => {
    try {
      const response = await fetchTicketStatus(token);
      if (response.data.statusValue === 200) {
        const status = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((status) => ({
            label: status.label,
            value: status.value,
          }));

        setTicketStatusOptions(status);
      } else {
        setTicketStatusOptions([]);
      }
    } catch (error) {
      console.error("Error fetching status", error);
    }
  };

  const fetchTicketTypeOptions = async () => {
    try {
      const response = await fetchTicketType(token);
      if (response.data.statusValue === 200) {
        const type = response.data.data
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((type) => ({
            label: type.label,
            value: type.value,
          }));

        setTicketTypeOptions(type);
      } else {
        setTicketTypeOptions([]);
      }
    } catch (error) {
      console.error("Error fetching ticket type", error);
    }
  };

  const filterOptions = [
    { label: "Critical Tickets", value: "critical" },
    { label: "Overdue Tickets", value: "overdue" },
    { label: "Re-opened Tickets", value: "reopen" },
    { label: "E1", value: "e1" },
    { label: "E2", value: "e2" },
    { label: "E3", value: "e3" },
    { label: "Non-Violated", value: "nonviolated" },
  ];

  const statusOptions = [
    { label: "Open", value: "Open" },
    { label: "Closed", value: "Closed" },
  ];

  const handleCheckboxChange = (value) => {
    setSelectedFilters((prevFilters) =>
      prevFilters.includes(value)
        ? prevFilters.filter((filter) => filter !== value)
        : [...prevFilters, value]
    );
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const fetchCompaniesData = async () => {
    try {
      const response = await fetchCompanies();
      if (response.data.statusValue === 200) {
        const companies = response.data.data
          .sort((a, b) => a.companyName.localeCompare(b.companyName))
          .map((company) => ({
            label: company.companyName,
            value: company.companyName,
          }));

        setCompanyOptions(companies);
      } else {
        setCompanyOptions([]);
      }
    } catch (error) {
      console.error("Error fetching company names", error);
    }
  };

  const fetchCategoriesAndSubCategoriesData = async () => {
    try {
      const response = await fetchCategoriesAndSubCategories();
      if (response.data.statusValue === 200) {
        const categories = response.data.data
          .sort((a, b) => a.category.localeCompare(b.category))
          .map((item) => ({
            label: item.category,
            value: item.category,
          }));

        setCategoryOptions(categories);

        const subCategories = response.data.data.map((item) => ({
          category: item.category,
          subCategories: item.subCategories
            .map((sub) => ({
              label: sub,
              value: sub,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)), // Sort subcategories alphabetically
        }));

        setAllSubCategoryOptions(subCategories);
      } else {
        setCategoryOptions([]);
        setAllSubCategoryOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  const fetchQuickFilter = async () => {
    try {
      const response = await quickFilter();
      if (response.data.statusValue === 200) {
        const quickFilter = response.data.data.map((e) => ({
          label: e.label,
          filter: e.filter, // Pass the entire filter object
        }));

        const typeRR = response.data.raiseTicket
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((type) => ({
            label: type.label,
            value: type.ticketType,
            status: type.forClient
          }));

        setQuick(quickFilter);
        setDataRaiseTT(typeRR);
      } else {
        setQuick([]);
        setDataRaiseTT([]);
      }
    } catch (error) {
      console.error("Error fetching quick filter", error);
    }
  };


  const fetchDepartmentOptionsForReassign = async() => {
    try {
      const response = await fetchDepartmentForReassign();
      if (response.data.statusValue === 200) {
        const departments = response.data.data.sort((a, b) =>
          a.label.localeCompare(b.label)
        ).map((dept) => ({
          label: dept.label,
          value: dept.value,
        }));

       setDepartmentOptionForReassign(departments)
      } else {
        setDepartmentOptionForReassign([]);
      }
    } catch (error) {
      console.error("Error fetching department names", error);
    }
  }

  const filteredAssignees = departmentOptionForReassign.filter(
    (dept) => dept.value !== ticketDetails?.assignee[0].groupType
  );
  
  useEffect(() => {
    fetchCompaniesData();
    fetchCategoriesAndSubCategoriesData();
    fetchDepartmentOptions();
    fetchTicketStatusOptions();
    fetchTicketTypeOptions();
    fetchQuickFilter();
    fetchDepartmentOptionsForReassign();

  }, []);

  useEffect(() => {
    if (selectedCategories.length > 0) {
      setSelectedSubCategories([]); // Reset subcategory selection when category changes
    }
  }, [selectedCategories]);

  useEffect(() => {
    if (selectedCategories.length === 0) {
      setFilteredSubCategoryOptions([]);
    } else {
      const filteredSubCategories = allSubCategoryOptions
        .filter((option) =>
          selectedCategories.some((cat) => cat.value === option.category)
        )
        .flatMap((option) => option.subCategories);

      const uniqueSubCategoryOptions = [
        ...filteredSubCategories
          .reduce((map, obj) => {
            const key = `${obj.label}-${obj.value}`;
            if (!map.has(key)) {
              map.set(key, obj);
            }
            return map;
          }, new Map())
          .values(),
      ];

      setFilteredSubCategoryOptions(uniqueSubCategoryOptions);
    }
  }, [selectedCategories, allSubCategoryOptions]);

  const handleClearAll = () => {
    setSelectedCompanies([]);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedDepartments([]);
    setSelectedTicketTypes([]);
    setSelectedFilters([]);
    setSelectedStatus("");
    setFromDate("");
    setToDate("");
    setSelectedStatus("");
    setFilterCount(0);
    setSelectedTicketStatus([]);
    setSelectedRatings([]);
    // getTicketCountData(); // because it loads the page
  };

  const handleClearAllTcikets = () => {
    if (!isApplyFilterDisabled) {
      handleClearAll();
      setActiveTab("open");
      setFilterTab("open");
      setTickets([]);
      setCurrentPage(1);
      setSearchQuery("");
    }

    // Reset toggle states and filters
    setCheckedStates((prevState) =>
      Object.keys(prevState).reduce((acc, key) => {
        acc[key] = false; // Set all toggle states to false
        return acc;
      }, {})
    );

    setSelectedTicketTypes([]); // Clear selected ticket types
    setShowClearAll(false);
    setSelectedTicketId(null);
    setApplyFilterValue(null);
  };

  const handleSubmit = async () => {
    setActiveTab("Filter");
    setSearchQuery("");
    setTickets([]);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (applyFilterValue) {
      const callApiData = async () => {
        try {
          await fetchFilterData();
          await getTicketCountData();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      callApiData();
    }
  }, [applyFilterValue]);

  // Function to create an array of star icons
  const createStarLabel = (count) => (
    <div style={{ display: "flex" }}>
      {[...Array(count)].map((_, index) => (
        <img
          key={index}
          src={starIcon}
          alt="star"
          style={{ width: 20, height: 20, marginRight: 2 }}
        />
      ))}
    </div>
  );

  const ratingsOptions = [
    { label: "Not rated yet", value: "notRated" },
    { label: createStarLabel(1), value: "1" },
    { label: createStarLabel(2), value: "2" },
    { label: createStarLabel(3), value: "3" },
    { label: createStarLabel(4), value: "4" },
    { label: createStarLabel(5), value: "5" },
  ];

  useEffect(() => {
    setIsApplyFilterDisabled(
      selectedCompanies.length === 0 &&
        selectedCategories.length === 0 &&
        selectedSubCategories.length === 0 &&
        selectedDepartments.length === 0 &&
        selectedTicketTypes.length === 0 &&
        selectedFilters.length === 0 &&
        selectedStatus === "" &&
        selectedTicketStatus.length === 0 &&
        selectedRatings.length === 0 &&
        (fromDate === undefined || toDate === undefined)
    );
  }, [
    selectedCompanies,
    selectedCategories,
    selectedSubCategories,
    selectedDepartments,
    selectedTicketTypes,
    selectedFilters,
    selectedStatus,
    selectedTicketStatus,
    selectedRatings,
    fromDate,
    toDate,
  ]);

  const fetchFilterData = async () => {
    try {
      setLoading(true);

      setSelectedTicketId(null);

      if (!filterTab) {
        setFilterTab(activeTab);
      }

      if (!filterTab) return;

      const selectedCompaniesValue =
        applyFilterValue?.selectedCompanies.length === companyOptions.length
          ? []
          : applyFilterValue?.selectedCompanies.map((data) => data.value);

      const selectedCategoriesValue =
        applyFilterValue?.selectedCategories.length === categoryOptions.length
          ? []
          : applyFilterValue?.selectedCategories.map((data) => data.value);

      const selectedSubCategoriesValue =
        applyFilterValue?.selectedSubCategories.length ===
        filteredSubCategoryOptions.length
          ? []
          : applyFilterValue?.selectedSubCategories.map((data) => data.value);

      const selectedDepartmentsValue =
        applyFilterValue?.selectedDepartments.length ===
        departmentOptions.length
          ? []
          : applyFilterValue?.selectedDepartments.map((data) => data.value);

      const selectedTicketTypesValue =
        applyFilterValue?.selectedTicketTypes.length ===
        ticketTypeOptions.length
          ? []
          : applyFilterValue?.selectedTicketTypes.map((data) => data.value);

      const selectedFiltersValue = filterTab;

      const selectedTicketStatusValue =
        applyFilterValue?.selectedTicketStatus.length ===
        ticketStatusOptions.length
          ? []
          : applyFilterValue?.selectedTicketStatus.map((data) => data.value);

      const selectedCRatingsValue =
        applyFilterValue?.selectedRatings.length === ratingsOptions.length
          ? []
          : applyFilterValue?.selectedRatings.map((data) => data.value);

      const response = await fetchFilterTickets(
        currentPage,
        selectedFiltersValue,

        selectedCompaniesValue,

        selectedDepartmentsValue,

        selectedCategoriesValue,

        selectedSubCategoriesValue,

        selectedTicketTypesValue,

        selectedTicketStatusValue,

        selectedCRatingsValue,
        applyFilterValue?.fromDate,
        applyFilterValue?.toDate,
        selectedLocation.map((data) => data.value)
      );

      if (response?.status === 200) {
        const newTickets = response.data.data;

        if (newTickets.length === 0) {
          setHasMoreTickets(false);
          setShowClearAll(true);
        } else {
          setShowClearAll(true);

          setHasMoreTickets(true);

          setTickets((prevTickets) => {
            const combinedTickets = [...prevTickets, ...newTickets];

             const uniqueTickets = removeDuplicates(combinedTickets);


            setTicketDetails(uniqueTickets[0]);

            return uniqueTickets;
          });
        

          // if(tickets.length === 0 && newTickets.length > 0){

          //   setTicketDetails(newTickets[0])

          // }
        }
      } else {
        setTickets([]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (hasMoreTickets) {
  //     fetchFilterData(currentPage + 1, activeTab);
  //   }
  // }, [hasMoreTickets]);

  useEffect(() => {
    const ab = selectedCompanies.length > 0 ? 1 : 0;
    const bc = selectedCategories.length > 0 ? 1 : 0;
    const cd = selectedSubCategories.length > 0 ? 1 : 0;
    const de = selectedDepartments.length > 0 ? 1 : 0;
    const ef = selectedTicketTypes.length > 0 ? 1 : 0;
    const fg = selectedFilters.length > 0 ? 1 : 0;
    const st = fromDate === undefined || fromDate === "" ? 0 : 1;
    const uv = toDate === undefined || toDate === "" ? 0 : 1;
    const gh = selectedStatus === "" ? 0 : 1;
    const nm = selectedTicketStatus.length > 0 ? 1 : 0;
    const kl = selectedRatings.length > 0 ? 1 : 0;

    const totalSum = ab + bc + cd + de + ef + fg + st + uv + gh + nm + kl;

    setFilterCount(totalSum);
  }, [
    fromDate,
    selectedCategories.length,
    selectedCompanies,
    selectedDepartments.length,
    selectedFilters.length,
    selectedStatus,
    selectedSubCategories,
    selectedTicketTypes.length,
    selectedTicketStatus.length,
    selectedRatings.length,
    toDate,
  ]);

  const handleChange = (selected) => {
    setSelectedLocation(selected);
    setSearchQuery("");
    //setActiveTab("Location");
    if (!globalTicket) {
      setActiveTab("open");
    }
    setTickets([]);
    setCurrentPage(1);
    setTicketDetails(null);
    handleClearAll();
    setSelectedTicketId(null);
    setFilterTab("open"); // bug 9
    // setShowClearAll(false)
  };

  const getTicketCountDataRefresh = async (query) => {
    try {
      const selectedLocationValue = selectedLocation.map(
        (location) => location.value
      );
      const selectedCompaniesValue =
        selectedCompanies.length === companyOptions.length
          ? []
          : selectedCompanies.map((data) => data.value);
      const selectedCategoriesValue =
        selectedCategories.length === categoryOptions.length
          ? []
          : selectedCategories.map((data) => data.value);
      const selectedSubCategoriesValue =
        selectedSubCategories.length === filteredSubCategoryOptions.length
          ? []
          : selectedSubCategories.map((data) => data.value);
      const selectedDepartmentsValue =
        selectedDepartments.length === departmentOptions.length
          ? []
          : selectedDepartments.map((data) => data.value);
      const selectedTicketTypesValue =
        selectedTicketTypes.length === ticketTypeOptions.length
          ? []
          : selectedTicketTypes.map((data) => data.value);

      const selectedTicketStatusValue =
        selectedTicketStatus.length === ticketStatusOptions.length
          ? []
          : selectedTicketStatus.map((data) => data.value);
      const selectedCRatingsValue =
        selectedRatings.length === ratingsOptions.length
          ? []
          : selectedRatings.map((data) => data.value);

      const response = await getTicketCounts(
        selectedLocationValue,
        selectedCompaniesValue,
        selectedDepartmentsValue,
        selectedCategoriesValue,
        selectedSubCategoriesValue,
        selectedTicketTypesValue,
        selectedTicketStatusValue,
        selectedCRatingsValue,
        fromDate,
        toDate,
        query
      );
      if (response?.data?.statusValue === 200) {
        setTicketCount(response?.data?.data);
      } else {
        setTicketCount({});
      }
    } catch (error) {
      return {};
    } finally {
    }
  };

  //auto refresh
  useEffect(() => {
    const fetchRefreshData = async () => {
      try {
        let response;
        if (activeTab === "opened") {
          response = await fetchMyTickets(1, activeTab?.toLowerCase(),
          selectedLocation.map((location) => location.value).join(","));
        } else if (activeTab === "close") {
          response = await fetchMyTickets(1,activeTab?.toLowerCase(),
          selectedLocation.map((location) => location.value).join(","));
        } 
        else {
          response = await fetchTickets(
            1,
            activeTab?.toLowerCase(),
            selectedLocation.map((location) => location.value).join(",")
          );
        }

        if (response?.data?.statusValue === 200) {
          const newTickets = response.data.data;
          if (newTickets.length > 0) {
            setTickets(newTickets)
           
          }
          if (ticketDetails !== null) setTicketDetails(newTickets[0]);
        } else {
          setTickets([]);
          toast.error(response?.data?.data?.message);
        }
      } catch (error) {
        showToast(
          `Error fetching login : ${error?.response?.data?.error?.message}`
        );
      }
    };

    
    if (
      activeTab !== "Search" &&
      activeTab !== "Filter" &&
      activeTab !== "Location" &&
      !globalTicket
    ) {
     
      if (selectedLocation.length > 0) {
        const intervalId = setInterval(() => {
          fetchRefreshData();
          getTicketCountDataRefresh();
          fetchMyTicketKpiCount();
        }, 120000);

        fetchRefreshData();
        fetchMyTicketKpiCount();
        getTicketCountDataRefresh();

        return () => clearInterval(intervalId);
      
    }
  }
  }, [activeTab, selectedLocation]);// Add proper dependencies

  const handleTabChange = (tab) => {
    setactiveTabDet(tab);
  };

  const getTicketCountData = async (query) => {
    try {
      setLoading(true);
      const selectedLocationValue = selectedLocation.map(
        (location) => location.value
      );
      const selectedCompaniesValue =
        selectedCompanies.length === companyOptions.length
          ? []
          : selectedCompanies.map((data) => data.value);
      const selectedCategoriesValue =
        selectedCategories.length === categoryOptions.length
          ? []
          : selectedCategories.map((data) => data.value);
      const selectedSubCategoriesValue =
        selectedSubCategories.length === filteredSubCategoryOptions.length
          ? []
          : selectedSubCategories.map((data) => data.value);
      const selectedDepartmentsValue =
        selectedDepartments.length === departmentOptions.length
          ? []
          : selectedDepartments.map((data) => data.value);
      const selectedTicketTypesValue =
        selectedTicketTypes.length === ticketTypeOptions.length
          ? []
          : selectedTicketTypes.map((data) => data.value);

      const selectedTicketStatusValue =
        selectedTicketStatus.length === ticketStatusOptions.length
          ? []
          : selectedTicketStatus.map((data) => data.value);
      const selectedCRatingsValue =
        selectedRatings.length === ratingsOptions.length
          ? []
          : selectedRatings.map((data) => data.value);

      const response = await getTicketCounts(
        selectedLocationValue,
        selectedCompaniesValue,
        selectedDepartmentsValue,
        selectedCategoriesValue,
        selectedSubCategoriesValue,
        selectedTicketTypesValue,
        selectedTicketStatusValue,
        selectedCRatingsValue,
        fromDate,
        toDate,
        query
      );
      if (response?.data?.statusValue === 200) {
        setTicketCount(response?.data?.data);
      } else {
        setTicketCount({});
      }
    } catch (error) {
      return {};
    } finally {
      setLoading(false);
    }
  };

  const fetchSearchResults = useCallback(async (query, page, location, redirect) => {
    try {
      setLoading(true);

      let filter = filterTab;
      if (globalTicket) {
        filter = "";
        setActiveTab("Search");
      }

      let response;
      if ((myTicketsTab === "opened" || myTicketsTab === "close") &&  !isTicketUser) {
        response = await searchMyTickets(
          query,
          page,
          filter,
          globalTicket ? [] : location,
          globalTicket ? redirect : ""
        );
      } 
      
      else if  ((myTicketsTab === "opened" || myTicketsTab === "close") &&  (isTicketUser && !isTicketManager)) {
        response = await searchMyTickets2(
          query,
          page,
          filter,
          globalTicket ? redirect : ""
        );
      }
      else if ((myTicketsTab !== "opened" || myTicketsTab !== "close") ) {
        response = await searchTickets(
          query,
          page,
          filter,
          globalTicket ? [] : location,
          globalTicket ? redirect : ""
        );
      }
      if (response?.statusValue === 200 && response?.searchQuery === query) {
        const newTickets = response.data;

        if (newTickets.length === 0) {
          setHasMoreTickets(false);
        } else {
          setHasMoreTickets(true);
          setTickets((prevTickets) => {
            const combinedTickets = [...prevTickets, ...newTickets];
            const uniqueTickets = removeDuplicates(combinedTickets);
            setTicketDetails(uniqueTickets[0]);
            return uniqueTickets;
          });
        }
      } else {
        setTickets([]);
        toast.error(response?.data?.data?.message);
      }
    } catch (error) {
      // showToast(
      //   `Error fetching search results: ${error?.response?.data?.error?.message}`
      // );
    } finally {
      setLoading(false);
    }
  }, [filterTab, globalTicket, removeDuplicates, showToast, myTicketsTab]);

  const debouncedFetchSearchResults = useCallback(
    debounce((query, location) => {
      fetchSearchResults(query, 1, location, 1);
      //getTicketCountData(query, location);
    }, 500),
    []
  );

  useEffect(() => {
    if (globalTicket) {
      setSearchQuery(globalTicket);
      //debouncedFetchSearchResults(globalTicket, 1);
      setActiveTab("Search");
    }
  }, [globalTicket]);

  const handleSearchInputChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setFilterTab("open");
    setactiveTabDet("overview");
    if (query === "") {
      handleClearSearch();
    } else {
      setIsSearching(true);
      setActiveTab("Search");
      setTickets([]);
      setCurrentPage(1);
      debouncedFetchSearchResults(
        query,
        selectedLocation.map((location) => location.value)
      );
      getTicketCountData(
        query,
        selectedLocation.map((location) => location.value)
      );
    }
  };

  const handleSearchInputKeyDown = (event) => {
    if (event.key === "Enter") {
      debouncedFetchSearchResults.cancel();
      debouncedFetchSearchResults(
        event.target.value,
        selectedLocation.map((location) => location.value)
      );
      getTicketCountData(
        event.target.value,
        selectedLocation.map((location) => location.value)
      );
    }
  };

  const handleClearSearch = () => {
    debouncedFetchSearchResults.cancel();
   if(isTicketUser && !isTicketManager) {setActiveTab("opened") } else{
    setActiveTab("open") 
   }
    setFilterTab("");
    setTickets([]);
    setactiveTabDet("overview");
    setCurrentPage(1);
    setSearchQuery("");
    setTicketDetails(null);
    setIsSearching(false);
  };

  const resetCommentBox = () => {
    setCommentBox("");
    setUploadedFilesComment([]);
    setCommentType(false);
  };

  const resetReassignBox = () => {
    setReassignBox("");
    setUploadedFilesReassign([]);
    setSelectedAssignee("");
  };


  const resetIrrelevantBox = () => {
    setIrrelevantBox("");
    setUploadedFilesIrrelevant([]);
  };

  const openNewTabWithRoute = () => {};

  // useEffect(() => {
  //   const updateTime = () => {
  //     const [hours, minutes] = time?.split(':').map(Number);
  //     const newDate = new Date();
  //     newDate.setHours(hours);
  //     newDate.setMinutes(minutes + 1);

  //     const newTime = newDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  //     setTime(newTime);
  //   };

  //   const intervalId = setInterval(updateTime, 60000);

  //   return () => clearInterval(intervalId);
  // }, [time]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (time?.includes(":")) {
        const [hours, minutes] = time.split(":").map(Number);
        if (!isNaN(hours) && !isNaN(minutes)) {
          const newDate = new Date();
          newDate.setHours(hours);
          newDate.setMinutes(minutes + 1);

          setTime(
            newDate.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
          );
        }
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [time]);

  // Use an effect to log the updated state after it changes
  useEffect(() => {
    console.log(checkedStates, "Updated checkedStates");
  }, [checkedStates]);

  useEffect(() => {
    if (checkedStates.Snag) {
      const snagOptions = ticketTypeOptions.filter(
        (option) => option.value === "snag" || option.value === "snag-internal"
      );
      setSelectedTicketTypes(snagOptions);
    } else if (checkedStates.Support) {
      const supportOptions = ticketTypeOptions.filter(
        (option) =>
          option.value === "support" ||
          option.value === "spoc" ||
          option.value === "internal"
      );
      setSelectedTicketTypes(supportOptions);
    }
  }, [checkedStates, ticketTypeOptions, setSelectedTicketTypes]);

  useEffect(() => {
    setCheckedStates(
      quick.reduce((acc, item) => {
        acc[item.label] = item.label === "All"; // Set "All" to true, others to false
        return acc;
      }, {})
    );
  }, [quick]);
  

  const handleToggleChange = (label, checked) => {
    // 1. Sab filter states reset karo
    setCheckedStates(
      quick.reduce((acc, item) => {
        acc[item.label] = false;
        return acc;
      }, {})
    );
    setSelectedTicketTypes([]);
    setSelectedTicketStatus([]);
    setSelectedCompanies([]);
    setSelectedDepartments([]);
    setSelectedCategories([]);
    setSelectedSubCategories([]);
    setSelectedRatings([]);
    setFromDate(undefined);
    setToDate(undefined);
  
    if (checked) {
      // 2. Sirf current filter ko true karo
      setCheckedStates((prevState) => ({
        ...prevState,
        [label]: true
      }));
  
      const quickFilterObj = quick.find((item) => item.label === label);
  
      // 3. Sirf jis filter me value hai, usko set karo
      if (quickFilterObj && quickFilterObj.filter) {
        // Pehle sab blank rakhte hain
        let filterObject = {
          selectedTicketTypes: [],
          selectedTicketStatus: [],
          selectedCompanies: [],
          selectedDepartments: [],
          selectedCategories: [],
          selectedSubCategories: [],
          selectedRatings: [],
        };
  
        // --- DefaultGroup logic yahan add karo ---
        if (quickFilterObj.filter.defaultGroup) {
          const departmentOption = departmentOptions.find(
            option => option.value === quickFilterObj.filter.defaultGroup
          );
          if (departmentOption) {
            filterObject.selectedDepartments = [departmentOption];
          }
          filterObject.groupType = quickFilterObj.filter.defaultGroup;
        }
  
        // Ab sirf jis key ka value hai, usko set karo
        Object.entries(quickFilterObj.filter).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            switch(key) {
              case 'ticketType':
                filterObject.selectedTicketTypes = ticketTypeOptions.filter(option => value.includes(option.value));
                break;
              case 'status':
                filterObject.selectedTicketStatus = ticketStatusOptions.filter(option => value.includes(option.value));
                break;
              case 'company':
                filterObject.selectedCompanies = companyOptions.filter(option => value.includes(option.value));
                break;
              case 'department':
                filterObject.selectedDepartments = departmentOptions.filter(option => value.includes(option.value));
                break;
              case 'category':
                filterObject.selectedCategories = categoryOptions.filter(option => value.includes(option.value));
                break;
              case 'subCategory':
                filterObject.selectedSubCategories = filteredSubCategoryOptions.filter(option => value.includes(option.value));
                break;
              case 'rating':
                filterObject.selectedRatings = ratingsOptions.filter(option => value.includes(option.value));
                break;
              default:
                filterObject[key] = value;
            }
          } else {
            filterObject[key] = value;
          }
        });
  
        // Ab sirf jis filter me value hai, usko set karo
        setSelectedTicketTypes(filterObject.selectedTicketTypes);
        setSelectedTicketStatus(filterObject.selectedTicketStatus);
        setSelectedCompanies(filterObject.selectedCompanies);
        setSelectedDepartments(filterObject.selectedDepartments);
        setSelectedCategories(filterObject.selectedCategories);
        setSelectedSubCategories(filterObject.selectedSubCategories);
        setSelectedRatings(filterObject.selectedRatings);
  
        // Reset tickets and current page before applying new filter
        setTickets([]);
        setCurrentPage(1);
        setTicketDetails(null);
        setSelectedTicketId(null);
  
        // Pass the entire filter object to the filter API
        filterDatakeLie(filterObject);
        handleSubmit();
      }
    } else {
      // Agar toggle off ho toh sab reset
      handleClearAll();
      setActiveTab("open");
      setFilterTab("open");
      setTickets([]);
      setCurrentPage(1);
      setSearchQuery("");
      setSelectedTicketTypes([]);
    }
  };
  const filterDatakeLie = (filterObject = {}) => {
    setApplyFilterValue((prevState) => ({
      ...prevState,
      selectedLocation,
      selectedCompanies: filterObject.selectedCompanies || selectedCompanies,
      selectedDepartments: filterObject.selectedDepartments || selectedDepartments,
      selectedCategories: filterObject.selectedCategories || selectedCategories,
      selectedSubCategories: filterObject.selectedSubCategories || selectedSubCategories,
      selectedTicketTypes: filterObject.selectedTicketTypes || selectedTicketTypes,
      fromDate,
      toDate,
      selectedRatings: filterObject.selectedRatings || selectedRatings,
      selectedTicketStatus: filterObject.selectedTicketStatus || selectedTicketStatus,
      ...filterObject // Include any additional filter properties
    }));
    setQuickClearFilterDisable(false);
  };

  const filterDatakeLie2 = (filterObject = {}) => {
    setApplyFilterValue((prevState) => ({
      ...prevState,
      selectedLocation,
      selectedCompanies: filterObject.selectedCompanies || selectedCompanies,
      selectedDepartments: filterObject.selectedDepartments || selectedDepartments,
      selectedCategories: filterObject.selectedCategories || selectedCategories,
      selectedSubCategories: filterObject.selectedSubCategories || selectedSubCategories,
      selectedTicketTypes: filterObject.selectedTicketTypes || selectedTicketTypes,
      fromDate,
      toDate,
      selectedRatings: filterObject.selectedRatings || selectedRatings,
      selectedTicketStatus: filterObject.selectedTicketStatus || selectedTicketStatus,
      ...filterObject // Include any additional filter properties
    }));
    setQuickClearFilterDisable(false);
  };

  const fetchUsersData = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_FILE_UPLOAD}core/users/me`
      );
      if (response.status === 200) {
        setUserDetails(response?.data?.data)
      }
    } catch (error) {
      console.error("Error fetching categories and subcategories", error);
    }
  };

  useEffect(()=> {
    fetchUsersData();
  },[])
  // Add this new function to fetch My Tickets KPI count
  const fetchMyTicketKpiCount = async () => {
    try {
      const response = await getMyTicketKpiCount();
      console.log('KPI Count API Response:', response);
      if (response?.data?.statusValue === 200) {
        console.log('Setting KPI Count:', response?.data?.data);
        setMyTicketKpiCount(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching My Tickets KPI:", error);
    }
  };

  const fetchUserRoles = async () => {
    try {
      const response = await getAssigneeBaseInfo();
      if (response?.statusValue === 200) {
  
        const roles = response?.data?.decodedUser?.roles || [];
        setUserRoles(roles);
        const isTicketManager = roles.includes('Ticket Manager');
        setIsTicketManager(isTicketManager);
        const isTicketUser = roles.includes('Ticket User');
        setIsTicketUser(isTicketUser);
  
        if (!isTicketUser && !isTicketManager) {
          handleLogOut();
          return;
        }
  
        const groupType = response?.data?.internalUser?.groupType || [];
     
  
        const hasAm = groupType.includes("am");
        setGroupTypeOpExistAm(hasAm, "groupType");
  
        const requiredGroupTypes = ["am", "tc", "vs", "ho", "md"];
        const hasRequiredGroupType = groupType.some(type => {
          const match = requiredGroupTypes.includes(type);
          return match;
        });
        setGroupTypeForExComment(hasRequiredGroupType, "groupType");

        const hasOnlyOp = groupType.length === 1 && groupType[0] === "op";
        setGroupTypeOpsExist(hasOnlyOp); 
        
      }
    } catch (error) {
      console.error('Error fetching user roles:', error);
    } 
  };

 

  useEffect(() => {
  

    fetchUserRoles();
  }, []);

  console.log(userRoles, isTicketManager, isTicketUser,"MyTicketsBasic")

  return (
    <>
      <Fragment>
        <Header
          handleSearchInputChange={handleSearchInputChange}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          isSearching={isSearching}
          setIsSearching={setIsSearching}
          handleClearSearch={handleClearSearch}
          handleSearchInputKeyDown={handleSearchInputKeyDown}
          setCurrentPage={setCurrentPage}
          setActiveTab={setActiveTab}
          setRaiseticketStatud={setRaiseticketStatud}
          dataRaiseTT={dataRaiseTT}
          userDetails={userDetails}
          isTicketUser={isTicketUser}
        />

        <div className="wrapper d-flex">
          <Sidebar
            onTabChange={handleTabChange}
            filterTab={filterTab}
            setFilterTab={setFilterTab}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            locationData={locationData}
            selectedLocation={selectedLocation}
            handleChange={handleChange}
            ticketCount={ticketCount}
            loading={loading}
            myTicketKpiCount={myTicketKpiCount}
            isTicketManager={isTicketManager}
            isTicketUser={isTicketUser}
            fetchUserRoles={fetchUserRoles}
          />
        </div>

        <section className="MainContent">
       
        {console.log(selectedLocation,"selectedLocatikhuson")}

          <main>
            <div className="container-fluid">
              <div className="row">
                {loading && currentPage === 1 ? (
                  <div className="d-flex align-items-center justify-content-center heightNodData">
                    <img
                      src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                      width={50}
                      alt="company logo"
                    />
                  </div>
                ) : (tickets.length === 0 && !loading)  ||  selectedLocation.length === 0 
               ? (
                  <div className="col-12">
                    <div className="d-flex">
                      <div className="NoDataFilterContainer">
                        <Filter
                          filterOptions={filterOptions}
                          selectedFilters={selectedFilters}
                          handleCheckboxChange={handleCheckboxChange}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          statusOptions={statusOptions}
                          selectedStatus={selectedStatus}
                          handleStatusChange={handleStatusChange}
                          ticketTypeOptions={ticketTypeOptions}
                          selectedTicketTypes={selectedTicketTypes}
                          setSelectedTicketTypes={setSelectedTicketTypes}
                          departmentOptions={departmentOptions}
                          selectedDepartments={selectedDepartments}
                          setSelectedDepartments={setSelectedDepartments}
                          companyOptions={companyOptions}
                          selectedCompanies={selectedCompanies}
                          setSelectedCompanies={setSelectedCompanies}
                          categoryOptions={categoryOptions}
                          selectedCategories={selectedCategories}
                          setSelectedCategories={setSelectedCategories}
                          filteredSubCategoryOptions={
                            filteredSubCategoryOptions
                          }
                          selectedSubCategories={selectedSubCategories}
                          setSelectedSubCategories={setSelectedSubCategories}
                          handleClearAll={handleClearAll}
                          handleSubmit={handleSubmit}
                          isApplyFilterDisabled={isApplyFilterDisabled}
                          handleClearAllTcikets={handleClearAllTcikets}
                          filterCount={filterCount}
                          showClearAll={showClearAll}
                          setSelectedTicketStatus={setSelectedTicketStatus}
                          selectedTicketStatus={selectedTicketStatus}
                          ticketStatusOptions={ticketStatusOptions}
                          ratingsOptions={ratingsOptions}
                          selectedRatings={selectedRatings}
                          setSelectedRatings={setSelectedRatings}
                          selectedLocation={selectedLocation}
                          setApplyFilterValue={setApplyFilterValue}
                          applyFilterValue={applyFilterValue}
                          supportTicketChecked={supportTicketChecked}
                          setSupportTicketChecked={setSupportTicketChecked}
                          quick={quick}
                          checkedStates={checkedStates}
                          quickClearFilterDisable={quickClearFilterDisable}
                          handleToggleChange={handleToggleChange}
                          filterDatakeLie={filterDatakeLie}
                          filterDatakeLie2={filterDatakeLie2}
                          activeTab={activeTab}
                        />
                      </div>
                      {activeTab === "Filter" ? (
                        <div className="NoTicketsContainer">
                          <div className="NoTicketsBox">
                            <img src={NoDataBg} alt="" />
                            <p className="">
                              No tickets available for this filter
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="NoTicketsContainer">
                          <div className="NoTicketsBox">
                            <img src={NoDataBg} alt="" />
                            <p className="">No data available to show</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-md-4_no tickets-column ticketsList_Column">
                      <Filter
                        filterOptions={filterOptions}
                        selectedFilters={selectedFilters}
                        handleCheckboxChange={handleCheckboxChange}
                        fromDate={fromDate}
                        toDate={toDate}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        statusOptions={statusOptions}
                        selectedStatus={selectedStatus}
                        handleStatusChange={handleStatusChange}
                        ticketTypeOptions={ticketTypeOptions}
                        selectedTicketTypes={selectedTicketTypes}
                        setSelectedTicketTypes={setSelectedTicketTypes}
                        departmentOptions={departmentOptions}
                        selectedDepartments={selectedDepartments}
                        setSelectedDepartments={setSelectedDepartments}
                        companyOptions={companyOptions}
                        selectedCompanies={selectedCompanies}
                        setSelectedCompanies={setSelectedCompanies}
                        categoryOptions={categoryOptions}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        filteredSubCategoryOptions={filteredSubCategoryOptions}
                        selectedSubCategories={selectedSubCategories}
                        setSelectedSubCategories={setSelectedSubCategories}
                        handleClearAll={handleClearAll}
                        handleSubmit={handleSubmit}
                        isApplyFilterDisabled={isApplyFilterDisabled}
                        handleClearAllTcikets={handleClearAllTcikets}
                        filterCount={filterCount}
                        showClearAll={showClearAll}
                        setSelectedTicketStatus={setSelectedTicketStatus}
                        selectedTicketStatus={selectedTicketStatus}
                        ticketStatusOptions={ticketStatusOptions}
                        ratingsOptions={ratingsOptions}
                        selectedRatings={selectedRatings}
                        setSelectedRatings={setSelectedRatings}
                        selectedLocation={selectedLocation}
                        setApplyFilterValue={setApplyFilterValue}
                        applyFilterValue={applyFilterValue}
                        supportTicketChecked={supportTicketChecked}
                        setSupportTicketChecked={setSupportTicketChecked}
                        quick={quick}
                        checkedStates={checkedStates}
                        quickClearFilterDisable={quickClearFilterDisable}
                        handleToggleChange={handleToggleChange}
                        filterDatakeLie={filterDatakeLie}
                        filterDatakeLie2={filterDatakeLie2}
                        activeTab={activeTab}
                      />
                      <div className="ticketListContainer">
                        {tickets.map((ticket, index) => {
                          console.log(ticket,"step2")
                          if (tickets.length === index + 1) {
                            return (
                              <div ref={lastTicketElementRef} key={uuidv4()}>
                                <Ticket
                                  ticketDetailsId={ticketDetails}
                                  ticket={ticket}
                                  handleButtonClick={handleButtonClick}
                                  handleSelectButtonClick={
                                    handleSelectButtonClick
                                  }
                                  selectedTicketId={selectedTicketId}
                                  openNewTabWithRoute={openNewTabWithRoute}
                                />
                              </div>
                            );
                          } else {
                            return (
                              <Ticket
                                ticketDetailsId={ticketDetails}
                                key={uuidv4()}
                                ticket={ticket}
                                handleButtonClick={handleButtonClick}
                                handleSelectButtonClick={
                                  handleSelectButtonClick
                                }
                                selectedTicketId={selectedTicketId}
                                openNewTabWithRoute={openNewTabWithRoute}
                              />
                            );
                          }
                        })}

                        {tickets.length > 20 && showLoader && (
                          <div className="loader-wrapper d-flex align-items-center justify-content-center">
                            <img
                              className=""
                              src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                              style={{ width: "30px" }}
                              alt="Loading..."
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-8_no col p-0">
                      <TicketDetails
                        ticket={ticketDetails}
                        handleButtonClick={handleButtonClick}
                        handleCriticalButtonClick={handleCriticalButtonClick}
                        allData={allData}
                        escData={escData}
                        resetCommentBox={resetCommentBox}
                        resetReassignBox={resetReassignBox}
                        resetIrrelevantBox={resetIrrelevantBox}
                        allTicketData={allTicketData}
                        time={time}
                        setTime={setTime}
                        activeTabDet={activeTabDet}
                        setactiveTabDet={setactiveTabDet}
                        groupTypeOpExistAm={groupTypeOpExistAm}
                      />
                    </div>
                  </>
                )}
                {/* Change Status Modal */}
                <ChangeStatusModal
                  show={showChangeStatusModal}
                  onHide={() => setShowChangeStatusModal(false)}
                  modalButtonValue={modalButtonValue}
                  onSubmit={handleUpdateStatus}
                  ticket={ticketDetails}
                  allData={allData}
                  handleAddComment={handleAddComment}
                  commentbox={commentbox}
                  setCommentBox={setCommentBox}
                  uploadedFilesComment={uploadedFilesComment}
                  setUploadedFilesComment={setUploadedFilesComment}
                  handleReassign={handleReassign}
                  handleIrrelevant={handleIrrelevant}
                  reassignbox={reassignbox}
                  setReassignBox={setReassignBox}
                  irrelevantBox={irrelevantBox}
   setIrrelevantBox={setIrrelevantBox}
   uploadedFilesIrrelevant={uploadedFilesIrrelevant}
   setUploadedFilesIrrelevant={setUploadedFilesIrrelevant}
                  uploadedFilesReassign={uploadedFilesReassign}
                  setUploadedFilesReassign={setUploadedFilesReassign}
                  selectedAssignee={selectedAssignee}
                  setSelectedAssignee={setSelectedAssignee}
                  handleChangeAssignee={handleChangeAssignee}
                  filteredAssignees={filteredAssignees}
                  allTicketData={allTicketData}
                  commentType={commentType}
                  setCommentType={setCommentType}
                  groupTypeForExComment={groupTypeForExComment}
                  groupTypeOpsExist={groupTypeOpsExist}
                />

                <MarkCriticalModal
                  show={MarkCriticalModalShow}
                  onHide={() => setMarkCriticalModalShow(false)}
                  confirmAction={confirmCriticalAction}
                />
              </div>
            </div>
          </main>
        </section>
      </Fragment>

      {/* Start Dynamic Form Mandatory Field Modal */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-90w ChangeStatusModal"
        centered
      >
        <Modal.Body>
          <div className="ChangeStatusModalHead d-flex align-center justify-content-between">
            <h3>
              <span className="text-danger">*</span> Almost There!
            </h3>
            <a
              type="button"
              className="ChangeStatusModal_Close btn-close"
              aria-label="Close"
              onClick={handleClose}
            >
              &nbsp;
            </a>
          </div>
          <div className="ChangeStatusModalBody">
            <div className="ChangeStatusModalContent">
              <div className="ticketDetails_UserInfo d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <div className="ticketDetails_Name">
                    Just a few more details needed to close the ticket.
                    {/* The following fields are required to proceed: */}
                  </div>
                </div>
                <div></div>
              </div>
              <div className="AddNoteToTicket">
                <div className="ticketDetails_Name">
                  <ul className="text-danger mb-3">
                    {dynamicData &&
                      dynamicData.map((field, index) => (
                        <li key={index} className="text-capitalize">
                          • {field.replace(/([A-Z])/g, " $1").trim()}
                        </li>
                      ))}
                  </ul>
                  <div className="DynamicFormPopupHead">
                  {/* <h3>
                    Please click on "View Details" to fill in the required
                    information.
                  </h3> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="ChangeStatusModalFoot">
          <div className="ChangeStatusModalFoot_content">
            <div className="ModalToolCTA d-flex">
              {/* <button
                className="btn btn-dark ModalCTA_Dark"
                onClick={() => {
                  // Pass 'details' as the active tab when closing modal
                  setactiveTabDet("details");
                  handleClose();
                }}
              >
                View Details
              </button> */}
            </div>

            {/* <div className="ModalCTA">
              <button
                className="btn btn-dark ModalCTA_Dark"
                onClick={handleClose}
              >
                Close
              </button>
            </div> */}
            <div className="ModalCTA">
              <button
                className="btn btn-dark ModalCTA_Dark"
                onClick={() => {
                  // Pass 'details' as the active tab when closing modal
                  setactiveTabDet("details");
                  handleClose();
                }}
              >
                Fill Details
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* End Dynamic Form Mandatory Field Modal */}
    </>
  );
};

export default TicketLists;